// globals.js
export const globalParams = {
    // New field to store all parkings
    parkings: null
};

// Function to get agreement_id by parking_id
export function getAgreementId(parking_id) {
    if (!globalParams.parkings || !Array.isArray(globalParams.parkings)) {
        return null;
    }
    
    const parking = globalParams.parkings.find(p => p.parking_id === parking_id);
    return parking ? parking.agreement_id : null;
}

